export type CustomPackPayload = {
    name?: string;
    blackCardsText?: string;
    whiteCardsText?: string;
};

export function slugifyPackName(value: string) {
    return value
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 48);
}

export function parseCardLines(value: string | undefined) {
    return (value ?? "")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
}

export function parseBlackCardLine(line: string) {
    const explicitPick = line.match(/^(.*?)(?:\s*\|\|\s*(\d+))$/);
    const text = explicitPick ? explicitPick[1].trim() : line.trim();
    const underscorePick = (text.match(/_+/g) ?? []).length;
    const pick = explicitPick
        ? Math.max(1, Number.parseInt(explicitPick[2] ?? "1", 10) || 1)
        : Math.max(underscorePick, 1);

    if (!text) {
        throw new Error("Black cards cannot be blank.");
    }

    return {text, pick};
}

export function parseCustomPackPayload(body: CustomPackPayload) {
    const name = body.name?.trim() ?? "";
    if (!name) {
        throw new Error("Pack name is required.");
    }

    const blackCards = parseCardLines(body.blackCardsText).map(parseBlackCardLine);
    const whiteCards = parseCardLines(body.whiteCardsText);

    if (blackCards.length + whiteCards.length === 0) {
        throw new Error("Add at least one black or white card.");
    }

    return {name, blackCards, whiteCards};
}

export function formatBlackCardLine(text: string, pick: number) {
    const inferredPick = Math.max((text.match(/_+/g) ?? []).length, 1);
    if (pick > 1 && pick !== inferredPick) {
        return `${text} || ${pick}`;
    }
    return text;
}
